// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

import GridRow from "./grid_row";
import GridPagination from "./grid_pagination";

frappe.ui.form.get_open_grid_form = function () {
	return $(".grid-row-open").data("grid_row");
};

frappe.ui.form.close_grid_form = function () {
	var open_form = frappe.ui.form.get_open_grid_form();
	open_form && open_form.hide_form();

	// hide editable row too
	if (frappe.ui.form.editable_row) {
		frappe.ui.form.editable_row.toggle_editable_row(false);
	}
};

export default class Grid {
	constructor(opts) {
		$.extend(this, opts);
		this.fieldinfo = {};
		this.doctype = this.df.options;

		if (this.doctype) {
			this.meta = frappe.get_meta(this.doctype);
		}
		this.fields_map = {};
		this.template = null;
		this.multiple_set = false;
		if (
			this.frm &&
			this.frm.meta.__form_grid_templates &&
			this.frm.meta.__form_grid_templates[this.df.fieldname]
		) {
			this.template = this.frm.meta.__form_grid_templates[this.df.fieldname];
		}
		this.filter = {};
		this.is_grid = true;
		this.debounced_refresh = this.refresh.bind(this);
		this.debounced_refresh = frappe.utils.debounce(this.debounced_refresh, 100);
	}

	get perm() {
		return this.control?.perm || this.frm?.perm || this.df.perm;
	}

	set perm(_perm) {
		console.error("Setting perm on grid isn't supported, update form's perm instead");
	}

	allow_on_grid_editing() {
		if ((this.meta && this.meta.editable_grid) || !this.meta) {
			return true;
		} else {
			return false;
		}
	}

	make() {
		//// Neoffice — the grid-field template below carries four additions and nothing else; a marker cannot
		//// live inside a template literal, hence this single block:
		////   — the "Toggle Full Width" button beside the label, in a .d-flex wrapper (8a044787a8, 2025-11-07
		////     "Add full-width toggle to grid and improve VAT Declaration handling") — setup_fullwidth_toggle()
		////     below wires it. Upstream renders a bare <label class="control-label">;
		////   — the .grid-append-row CTA inside the table (64f4614afc, 2026-06-10 "feat(cockpit): grid
		////     redesign"), the cockpit's in-table "+ Add Row"; it shares the footer button's handler
		////     (setup_add_row, marked) and its visibility rules (refresh_remove_rows_button, marked);
		////   — inline SVG icons on Add Row / Add Multiple and icon-only Download / Upload (same commit), the
		////     labels surviving as title / aria-label;
		////   — the alt text of the empty-grid image goes through __() (upstream hard-codes "Grid Empty State" in
		////     English, so it showed as an English tooltip in a French UI).
		let template = `
			<div class="grid-field">
				<div class="d-flex align-items-center">
				<label class="control-label mb-0">${__(this.df.label || "", null, this.df.parent)}</label>
				<button type="button" class="btn btn-xs btn-default ml-2 grid-toggle-fullwidth" title="${__(
					"Toggle Full Width"
				)}" style="padding: 3px 5px; display: flex; margin-bottom: 3px;">
					<svg class="icon icon-xs"><use href="#es-line-expand"></use></svg>
				</button>
			</div>
				<span class="help"></span>
				<p class="text-muted small grid-description"></p>
				<div class="grid-custom-buttons"></div>
				<div class="form-grid-container">
					<div class="form-grid">
						<div class="grid-heading-row"></div>
						<div class="grid-body">
							<div class="rows"></div>
							<div class="grid-empty text-center">
								<!-- //// Neoffice — the empty state's alt text goes through __() (1e42eee4de "fix(i18n): alt texts of the empty states and of the report toolbar icons go through __()") -->
								<img
									src="/assets/frappe/images/ui-states/grid-empty-state.svg"
									alt="${__("Grid Empty State")}"
									class="grid-empty-illustration"
								>
								${__("No Data")}
							</div>
							<!-- //// Neoffice — added: the cockpit's in-table "+ Add Row" CTA (64f4614afc 2026-06-10 "feat(cockpit): grid redesign"; see the marker above make()) -->
							<button type="button" class="grid-append-row hidden">
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
									stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>${__("Add Row")}
							</button>
						</div>
					</div>
				</div>
				<div class="small form-clickable-section grid-footer">
					<div class="flex justify-between">
						<div class="grid-buttons">
							<button type="button" class="btn btn-xs btn-danger grid-remove-rows hidden"
								data-action="delete_rows">
								${__("Delete")}
							</button>
							<button type="button" class="btn btn-xs btn-danger grid-remove-all-rows hidden"
								data-action="delete_all_rows">
								${__("Delete All")}
							</button>
							<!-- hack to allow firefox include this in tabs -->
							<button type="button" class="btn btn-xs btn-secondary grid-add-row">
								<!-- //// Neoffice — inline icon before the label (64f4614afc 2026-06-10, cockpit grid redesign); upstream shows the label only -->
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
									stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>${__("Add Row")}
							</button>
							<button type="button" class="grid-add-multiple-rows btn btn-xs btn-secondary hidden">
								<!-- //// Neoffice — inline icon before the label (64f4614afc 2026-06-10, cockpit grid redesign); upstream shows the label only -->
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
									stroke-linecap="round"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>${__(
				"Add Multiple"
			)}
							</button>
						</div>
						<div class="grid-pagination">
						</div>
						<div class="grid-bulk-actions text-right">
							<!-- //// Neoffice — icon-only Download button, the label kept as title / aria-label (64f4614afc 2026-06-10, cockpit grid redesign) -->
							<button type="button" class="grid-download btn btn-xs btn-secondary grid-icon-btn hidden"
								title="${__("Download")}" aria-label="${__("Download")}">
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
									stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>
							</button>
							<!-- //// Neoffice — icon-only Upload button, the label kept as title / aria-label (64f4614afc 2026-06-10, cockpit grid redesign) -->
							<button type="button" class="grid-upload btn btn-xs btn-secondary grid-icon-btn hidden"
								title="${__("Upload")}" aria-label="${__("Upload")}">
								<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
									stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>
							</button>
						</div>
					</div>
				</div>
			</div>
		`;

		this.wrapper = $(template).appendTo(this.parent);
		$(this.parent).addClass("form-group");
		this.set_grid_description();
		this.set_doc_url();

		frappe.utils.bind_actions_with_object(this.wrapper, this);

		this.form_grid = this.wrapper.find(".form-grid");

		this.setup_add_row();

		this.setup_grid_pagination();
		this.update_idx_and_name();

		this.custom_buttons = {};
		this.grid_buttons = this.wrapper.find(".grid-buttons");
		this.grid_custom_buttons = this.wrapper.find(".grid-custom-buttons");
		this.remove_rows_button = this.grid_buttons.find(".grid-remove-rows");
		this.remove_all_rows_button = this.grid_buttons.find(".grid-remove-all-rows");

		this.setup_allow_bulk_edit();
		this.setup_check();
		//// Neoffice — added call (8a044787a8, 2025-11-07): wires the Toggle Full Width button of the template
		//// above. The method it calls is ours too, right below.
		this.setup_fullwidth_toggle();
		//// Neoffice — added call (maintenance#2001): a mainly vertical swipe that starts over a grid in
		//// horizontal-scroll mode moves the page instead of sticking to the grid. The method is ours, below.
		this.setup_vertical_wheel_handoff();
		if (this.df.on_setup) {
			this.df.on_setup(this);
		}
	}

	//// Neoffice — added method, no upstream equivalent (v15 or develop): expands a child table to a
	//// 95vw x 95vh overlay. History, because the shape matters at the merge: 8a044787a8 (2025-11-07)
	//// shipped an inline "full width" toggle, 56c29f4324 (2026-05-08) made it a modal dialog and
	//// 5a4bfb7b7c the same day dropped the DOM transplant it needed — moving the grid-field detached the
	//// listeners bound to the form column, breaking Add Row and the sub-dialogs. Since then the
	//// grid-field never moves: only a class (position: fixed) plus a backdrop. Then dccea87d29 and
	//// c31e75693c (force_search_row, read by grid_row.js#show_search_row — marked there) forced the
	//// per-column search row visible, and on 2026-07-28 7bde977a72 / b793769888 / 9e59d27acf made the
	//// overlay a continuous scroll: unbounded page length (a length frozen at open time re-paginated as
	//// soon as a row was added) and rows beyond the page window dropped on close, since truncate_rows()
	//// only fires when the data shrinks. Styles in scss/common/grid.scss.
	setup_fullwidth_toggle() {
		// Zoom the grid to a near-fullscreen overlay WITHOUT moving it in
		// the DOM. We just toggle a class on the grid-field that makes it
		// `position: fixed` 95vw × 95vh, plus a backdrop. This keeps every
		// JS reference, every event binding, and the parent form layout
		// intact — Add Row, calc, save, sub-dialogs (item search, batch
		// picker, etc.) all keep working as if nothing changed.
		const toggle_btn = this.wrapper.find(".grid-toggle-fullwidth");
		const grid_field = this.wrapper;
		const me = this;

		const BACKDROP_CLASS = "grid-fullscreen-backdrop";
		const FULLSCREEN_CLASS = "grid-fullscreen";

		// Continuous flow in fullscreen: the whole table in one scroll, no
		// "page 1 / 2" past 50 rows. Pagination stays ON in the inline grid,
		// where it is what keeps a 500-row form responsive (it bounds every
		// re-render to one page).
		const set_continuous = (on) => {
			const gp = me.grid_pagination;
			if (!gp) return;
			const default_length = me.meta?.grid_page_length || 50;
			if (on) {
				// A fixed length taken at open time breaks as soon as a row is
				// added while in fullscreen (total_pages would become 2 and a
				// single row would show). An effectively unbounded page keeps
				// the view continuous whatever happens to the data.
				gp.page_length = 1e6;
			} else {
				gp.page_length = default_length;
				// Drop the rows rendered beyond the page window. truncate_rows()
				// only fires when the DATA shrinks, so without this the inline
				// grid would keep every fullscreen row in the DOM and lose the
				// very benefit pagination provides. They are rebuilt on demand
				// when the user pages forward.
				if (me.grid_rows && me.grid_rows.length > default_length) {
					for (let i = default_length; i < me.grid_rows.length; i++) {
						const gr = me.grid_rows[i];
						if (!gr) continue;
						if (gr.wrapper) gr.wrapper.remove();
						if (gr.doc && me.grid_rows_by_docname) {
							delete me.grid_rows_by_docname[gr.doc.name];
						}
					}
					me.grid_rows.splice(default_length);
				}
			}
			gp.page_index = 1;
		};

		const close_fullscreen = () => {
			set_continuous(false);
			grid_field.removeClass(FULLSCREEN_CLASS);
			$(`body > .${BACKDROP_CLASS}`).remove();
			$(document).off("keydown.gridFullscreen");
			toggle_btn.removeClass("btn-primary").addClass("btn-default");
			// Drop the force flag so Frappe removes the filter row again
			// if there aren't enough rows to justify it
			me.force_search_row = false;
			$(me.parent).find(".grid-heading-row").removeClass("force-with-filter");
			// Recompute column widths in the original container, also
			// re-evaluates whether the search row should stay
			me.refresh();
		};

		const open_fullscreen = () => {
			set_continuous(true);
			grid_field.addClass(FULLSCREEN_CLASS);
			// Force the per-column filter/search row visible, even when
			// the row count is below Frappe's default threshold. The flag
			// is read by GridRow#show_search_row.
			me.force_search_row = true;
			$(me.parent).find(".grid-heading-row").addClass("force-with-filter");
			// Backdrop catches clicks-outside and ESC.
			const $backdrop = $(`<div class="${BACKDROP_CLASS}"></div>`)
				.appendTo("body")
				.on("click", close_fullscreen);
			$(document).on("keydown.gridFullscreen", (e) => {
				if (e.key === "Escape") {
					e.preventDefault();
					close_fullscreen();
				}
			});
			toggle_btn.removeClass("btn-default").addClass("btn-primary");
			// Recompute column widths AND re-build the heading row so the
			// header_search/filter-row gets re-created (it was removed by
			// show_search_row when the row count was below threshold).
			setTimeout(() => {
				me.make_head();
				me.refresh();
			}, 50);
		};

		toggle_btn.on("click", () => {
			if (grid_field.hasClass(FULLSCREEN_CLASS)) {
				close_fullscreen();
			} else {
				open_fullscreen();
			}
		});
	}
	//// Neoffice — added method, no upstream equivalent (v15 or develop), for maintenance#2001. Past ten
	//// columns our grid scrolls sideways (.column-limit-reached: overflow-x scroll, overflow-y hidden, set in
	//// grid_row.js), and a browser picks the scroller of a WHOLE wheel gesture from its first event (scroll
	//// latching). A trackpad or Magic Mouse swipe that starts over the table with the slightest sideways
	//// drift latched onto the table, which cannot move vertically: the page stopped with the table under the
	//// pointer, and what follows it (taxes, totals) looked missing until a reload. Once the table had moved
	//// sideways, a drift either way latched. Measured on a Sales Invoice with a synthetic gesture (600 px
	//// down, 20 px sideways): page 0 px, table 20 px. A mainly vertical gesture the table would capture is
	//// handed to the nearest scroller that can move vertically (.main-section in the cockpit layout); a
	//// mainly sideways one still scrolls the table, and a gesture that starts straight down is left to the
	//// browser, which already scrolls the page.
	setup_vertical_wheel_handoff() {
		const container = this.wrapper.find(".form-grid-container").get(0);
		if (!container) return;
		const grid_field = this.wrapper;
		const HANDOFF_GAP = 150; // ms without a wheel event that ends a handed-off gesture
		let handing_off_until = 0;

		const can_scroll_x = (el, dx) =>
			dx < 0 ? el.scrollLeft > 0 : el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
		const can_scroll_y = (el, dy) => {
			const overflow_y = getComputedStyle(el).overflowY;
			if (!["auto", "scroll", "overlay"].includes(overflow_y)) return false;
			return dy < 0
				? el.scrollTop > 0
				: el.scrollTop + el.clientHeight < el.scrollHeight - 1;
		};
		// A scroller between the pointer and the grid (a long text in an open row) keeps the gesture
		const inner_scroller = (target, dy) => {
			for (let el = target; el && el !== container; el = el.parentElement) {
				if (el.nodeType === 1 && can_scroll_y(el, dy)) return true;
			}
			return false;
		};
		const page_scroller = (dy) => {
			for (let el = container.parentElement; el; el = el.parentElement) {
				if (el === document.body || el === document.documentElement) break;
				if (can_scroll_y(el, dy)) return el;
			}
			return document.scrollingElement;
		};

		container.addEventListener(
			"wheel",
			(e) => {
				// Not cancelable: the browser already latched this gesture elsewhere. ctrlKey: a pinch-zoom.
				// The fullscreen overlay scrolls both ways by itself, over a page that must stay still.
				if (!e.cancelable || e.ctrlKey || grid_field.hasClass("grid-fullscreen")) return;
				if (e.timeStamp > handing_off_until) {
					const mainly_vertical = Math.abs(e.deltaY) > Math.abs(e.deltaX);
					if (!mainly_vertical || !e.deltaX || !can_scroll_x(container, e.deltaX))
						return;
					if (can_scroll_y(container, e.deltaY) || inner_scroller(e.target, e.deltaY))
						return;
				}
				e.preventDefault();
				handing_off_until = e.timeStamp + HANDOFF_GAP;
				const unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? window.innerHeight : 1;
				const scroller = page_scroller(e.deltaY);
				if (scroller) scroller.scrollTop += e.deltaY * unit;
			},
			{ passive: false }
		);
	}
	set_grid_description() {
		let description_wrapper = $(this.parent).find(".grid-description");
		if (this.df.description) {
			description_wrapper.html(__(this.df.description));
		} else {
			description_wrapper.hide();
		}
	}

	update_idx_and_name() {
		this.data.forEach((d, ri) => {
			if (d.idx === undefined) {
				d.idx = ri + 1;
			}
			if (d.name === undefined) {
				d.name = this.get_random_name();
			}
		});
	}

	get_random_name() {
		return Math.random().toString(36).slice(2, 10);
	}

	set_doc_url() {
		let unsupported_fieldtypes = frappe.model.no_value_type.filter(
			(x) => frappe.model.table_fields.indexOf(x) === -1
		);

		if (
			!this.df.label ||
			!this.df?.documentation_url ||
			unsupported_fieldtypes.includes(this.df.fieldtype)
		)
			return;

		let $help = $(this.parent).find("span.help");
		$help.empty();
		$(`<a href="${this.df.documentation_url}" target="_blank">
			${frappe.utils.icon("help", "sm")}
		</a>`).appendTo($help);
	}

	setup_grid_pagination() {
		this.grid_pagination = new GridPagination({
			grid: this,
			wrapper: this.wrapper,
		});
	}

	setup_check() {
		this.wrapper.on("click", ".grid-row-check", (e) => {
			const $check = $(e.currentTarget);
			const checked = $check.prop("checked");
			const is_select_all = $check.parents(".grid-heading-row:first").length !== 0;
			const docname = $check.parents(".grid-row:first")?.attr("data-name");

			if (is_select_all) {
				// (un)check all visible checkboxes
				this.form_grid.find(".grid-row-check").prop("checked", checked);

				// set following rows as checked in model
				let result_length = this.grid_pagination.get_result_length();
				let page_index = this.grid_pagination.page_index;
				let page_length = this.grid_pagination.page_length;
				for (let ri = (page_index - 1) * page_length; ri < result_length; ri++) {
					this.grid_rows[ri].select(checked);
				}
			} else if (docname) {
				if (e.shiftKey && this.last_checked_docname) {
					this.check_range(docname, this.last_checked_docname, checked);
				}
				this.grid_rows_by_docname[docname].select(checked);
				this.last_checked_docname = docname;
			}
			this.refresh_remove_rows_button();
		});
	}

	/**
	 * Checks or unchecks all checkboxes between two rows (included), given their docnames.
	 * Rows are only checked only if both parameters are valid docnames.
	 * @param {string} docname1
	 * @param {string} docname2
	 */
	check_range(docname1, docname2, checked = true) {
		const row_1 = this.grid_rows_by_docname[docname1];
		const row_2 = this.grid_rows_by_docname[docname2];
		const index_1 = this.grid_rows.indexOf(row_1);
		const index_2 = this.grid_rows.indexOf(row_2);
		if (index_1 === -1 || index_2 === -1) return;
		const [start, end] = [index_1, index_2].sort((a, b) => a - b);
		const rows = this.grid_rows.slice(start, end + 1);
		for (const row of rows) {
			row.select(checked);
			row.row_check?.find(".grid-row-check").prop("checked", checked);
		}
	}

	delete_rows() {
		var dirty = false;

		let tasks = [];
		let selected_children = this.get_selected_children();
		selected_children.forEach((doc) => {
			tasks.push(() => {
				if (!this.frm) {
					this.df.data = this.get_data();
					this.df.data = this.df.data.filter((row) => row.idx != doc.idx);
				}
				this.grid_rows_by_docname[doc.name]?.remove();
				dirty = true;
			});
			tasks.push(() => frappe.timeout(0.1));
		});

		if (!this.frm) {
			tasks.push(() => {
				// reorder idx of df.data
				this.df.data.forEach((row, index) => (row.idx = index + 1));
			});
		}

		tasks.push(() => {
			if (dirty) {
				this.refresh();
				this.frm &&
					this.frm.script_manager.trigger(this.df.fieldname + "_delete", this.doctype);
			}
		});

		frappe.run_serially(tasks);

		this.wrapper.find(".grid-heading-row .grid-row-check:checked:first").prop("checked", 0);
		if (selected_children.length == this.grid_pagination.page_length) {
			this.scroll_to_top();
		}
	}

	delete_all_rows() {
		frappe.confirm(__("Are you sure you want to delete all rows?"), () => {
			this.frm.doc[this.df.fieldname] = [];
			$(this.parent).find(".rows").empty();
			this.grid_rows = [];
			this.refresh();
			this.frm &&
				this.frm.script_manager.trigger(this.df.fieldname + "_delete", this.doctype);
			this.frm && this.frm.dirty();
			this.scroll_to_top();
		});
	}

	scroll_to_top() {
		frappe.utils.scroll_to(this.wrapper);
	}

	select_row(name) {
		this.grid_rows_by_docname[name].select();
	}

	remove_all() {
		this.grid_rows.forEach((row) => {
			row.remove();
		});
	}

	refresh_remove_rows_button() {
		if (this.df.cannot_delete_rows) {
			return;
		}

		this.remove_rows_button.toggleClass(
			"hidden",
			this.wrapper.find(".grid-body .grid-row-check:checked:first").length ? false : true
		);

		let select_all_checkbox_checked = this.wrapper.find(
			".grid-heading-row .grid-row-check:checked:first"
		).length;
		let show_delete_all_btn =
			select_all_checkbox_checked && this.data.length > this.get_selected_children().length;
		this.remove_all_rows_button.toggleClass("hidden", !show_delete_all_btn);
	}

	//// Neoffice — added field (0642910c2f, 2026-07-25): backport of upstream frappe#22862 into our v15.
	//// grid_row.js#refresh_check calls the debounced version instead of refresh_remove_rows_button()
	//// (marked there), which re-scans the whole grid body on every call — O(rows^2) on a large table.
	//// Drop this once the fork reaches an upstream release that carries #22862.
	// Backport of frappe/frappe#22862 (perf): refresh_check() runs once per row
	// per render, and each call re-scans the whole grid body — O(rows²).
	debounced_refresh_remove_rows_button = frappe.utils.debounce(
		this.refresh_remove_rows_button,
		100
	);

	get_selected() {
		return (this.data || []).filter((doc) => doc.__checked).map((doc) => doc.name);
	}

	get_selected_children() {
		return (this.data || [])
			.map((row) => {
				return row.__checked ? row : 0;
			})
			.filter((d) => {
				return d;
			});
	}

	reset_grid() {
		this.visible_columns = [];
		this.grid_rows = [];

		$(this.parent).find(".grid-body .grid-row").remove();
		this.refresh();
	}

	make_head() {
		if (this.prevent_build) return;

		// labels
		if (this.header_row) {
			$(this.parent).find(".grid-heading-row .grid-row").remove();
		}
		this.header_row = new GridRow({
			parent: $(this.parent).find(".grid-heading-row"),
			parent_df: this.df,
			docfields: this.docfields,
			frm: this.frm,
			grid: this,
			configure_columns: true,
			header_row: true,
		});

		this.header_search = new GridRow({
			parent: $(this.parent).find(".grid-heading-row"),
			parent_df: this.df,
			docfields: this.docfields,
			frm: this.frm,
			grid: this,
			show_search: true,
		});
		this.header_search.row.addClass("filter-row");
		if (this.header_search.show_search || this.header_search.show_search_row()) {
			$(this.parent).find(".grid-heading-row").addClass("with-filter");
		} else {
			$(this.parent).find(".grid-heading-row").removeClass("with-filter");
		}

		this.filter_applied && this.update_search_columns();
	}

	update_search_columns() {
		for (const field in this.filter) {
			if (this.filter[field] && !this.header_search.search_columns[field]) {
				delete this.filter[field];
				this.data = this.get_data(this.filter_applied);
				break;
			}

			if (this.filter[field] && this.filter[field].value) {
				let $input = this.header_search.row_index.find("input");
				if (field && field !== "row-index") {
					$input = this.header_search.search_columns[field].find("input");
				}
				$input.val(this.filter[field].value);
			}
		}
	}

	refresh() {
		if (this.frm && this.frm.setting_dependency) return;

		this.filter_applied = Object.keys(this.filter).length !== 0;
		this.data = this.get_data(this.filter_applied);

		!this.wrapper && this.make();
		let $rows = $(this.parent).find(".rows");

		this.setup_fields();

		if (this.frm) {
			this.display_status = frappe.perm.get_field_display_status(
				this.df,
				this.frm.doc,
				this.perm
			);
		} else if (this.df.is_web_form && this.control) {
			this.display_status = this.control.get_status();
		} else {
			// not in form
			this.display_status = "Write";
		}

		if (this.display_status === "None") return;

		// redraw
		this.make_head();

		if (!this.grid_rows) {
			/** @type {GridRow[]} */
			this.grid_rows = [];
		}

		/** @type {Record<string, GridRow>} */
		this.grid_rows_by_docname = {};

		this.grid_pagination.update_page_numbers();
		this.render_result_rows($rows);
		this.grid_pagination.check_page_number();
		this.wrapper.find(".grid-empty").toggleClass("hidden", Boolean(this.data.length));

		// toolbar
		this.setup_toolbar();
		this.toggle_checkboxes(this.display_status !== "Read");

		// sortable
		if (this.is_sortable() && !this.sortable_setup_done) {
			this.make_sortable($rows);
			this.sortable_setup_done = true;
		}

		this.last_display_status = this.display_status;
		this.last_docname = this.frm && this.frm.docname;

		// red if mandatory
		this.form_grid.toggleClass("error", !!(this.df.reqd && !(this.data && this.data.length)));

		this.refresh_remove_rows_button();

		this.wrapper.trigger("change");

		//// Neoffice — added (4c842a98fc, 2023-10-30 "First change v15"; the commit gives no rationale): after
		//// every render, tags each .data-row containing an element with data-name="Freeline" / "Subtotal"
		//// with a matching class, for the line styling of the erpnextswiss sales documents. It runs on EVERY
		//// grid of EVERY doctype, inside the render path. TO REVIEW at the merge.
		//// added to handle freeline and subtotal
		//// Neoffice — the classes are first taken off every row, then put back where they belong: the grid reuses
		//// its row nodes by POSITION (render_result_rows swaps `grid_row.doc` and keeps the node), so a node that
		//// carried a Freeline or a Subtotal kept the class once another line took its place, and an article was
		//// drawn as text after a line was inserted in the middle or moved (found 13.10.2026, neoffice-maintenance#1519).
		this.wrapper.find(".data-row").removeClass("freeline subtotal");
		this.wrapper.find('[data-name="Freeline"]').parents(".data-row").addClass("freeline");
		this.wrapper.find('[data-name="Subtotal"]').parents(".data-row").addClass("subtotal");
		////
	}

	render_result_rows($rows) {
		if (!$rows) {
			$rows = $(this.parent).find(".rows");
		}

		let result_length = this.grid_pagination.get_result_length();
		let page_index = this.grid_pagination.page_index;
		let page_length = this.grid_pagination.page_length;
		let page_start = (page_index - 1) * page_length;
		if (!this.grid_rows) {
			return;
		}

		// index existing rows by doc object reference for identity-based matching
		let rows_by_doc = new Map();
		for (let row of this.grid_rows) {
			if (row?.doc) {
				rows_by_doc.set(row.doc, row);
			}
		}

		let matched_rows = new Set();

		for (var ri = page_start; ri < result_length; ri++) {
			var d = this.data[ri];
			if (!d) {
				return;
			}
			if (d.idx === undefined) {
				d.idx = ri + 1;
			}
			if (d.name === undefined) {
				d.name = this.get_random_name();
			}

			let grid_row = rows_by_doc.get(d);
			if (grid_row) {
				matched_rows.add(grid_row);
				grid_row.refresh();
			} else {
				grid_row = new GridRow({
					parent: $rows,
					parent_df: this.df,
					docfields: this.docfields,
					doc: d,
					frm: this.frm,
					grid: this,
				});
			}
			this.grid_rows[ri] = grid_row;
			this.grid_rows_by_docname[d.name] = grid_row;
		}

		// remove stale / invisible rows
		for (let [, row] of rows_by_doc) {
			if (!matched_rows.has(row)) {
				row.wrapper.remove();
			}
		}

		// reorder DOM from the first mismatch onward
		let $children = $rows.children();
		let page_count = result_length - page_start;
		let reorder_from = -1;
		for (let i = 0; i < page_count; i++) {
			if ($children.get(i) !== this.grid_rows[page_start + i].wrapper.get(0)) {
				reorder_from = i;
				break;
			}
		}
		if (reorder_from >= 0) {
			for (let ri = page_start + reorder_from; ri < result_length; ri++) {
				$rows.append(this.grid_rows[ri].wrapper);
			}
		}

		// clear non-visible slots to prevent duplicates and stale references
		for (let i = 0; i < this.grid_rows.length; i++) {
			if (i < page_start || i >= result_length) {
				delete this.grid_rows[i];
			}
		}

		if (this.grid_rows.length > this.data.length) {
			this.grid_rows.length = this.data.length;
		}
	}

	setup_toolbar() {
		const is_editable = this.is_editable();
		if (is_editable) {
			this.wrapper.find(".grid-footer").removeClass("hidden");

			// show, hide buttons to add rows
			if (this.cannot_add_rows || (this.df && this.df.cannot_add_rows)) {
				// add 'hidden' to buttons
				this.wrapper.find(".grid-add-row, .grid-add-multiple-rows").addClass("hidden");
			} else {
				// show buttons
				this.wrapper.find(".grid-add-row").removeClass("hidden");

				if (this.multiple_set) {
					this.wrapper.find(".grid-add-multiple-rows").removeClass("hidden");
				}
			}
		} else if (
			this.grid_rows.length < this.grid_pagination.page_length &&
			!this.df.allow_bulk_edit
		) {
			this.wrapper.find(".grid-footer").addClass("hidden");
		}

		// don't be tempted to use the `.hidden` class here
		// it is used in other logic for the same buttons and will cause conflicts
		this.wrapper
			.find(".grid-add-row, .grid-add-multiple-rows, .grid-upload")
			.toggleClass("d-none", !is_editable);
		//// Neoffice — added (e901cfb70a, 2026-06-10 "fix(cockpit): grid totals first-paint + append-row CTA
		//// visibility"): drives the visibility of the in-table CTA (.grid-append-row of the template above),
		//// which upstream does not have. The class alone decides (no jQuery .toggle(), whose inline display
		//// surfaced it on the legacy chrome over the stylesheet), and cannot_add_rows folds into the same
		//// condition.
		const append_row_hidden =
			!is_editable || this.cannot_add_rows || (this.df && this.df.cannot_add_rows);
		this.wrapper.find(".grid-append-row").toggleClass("hidden", Boolean(append_row_hidden));
	}

	setup_fields() {
		// reset docfield
		if (this.frm && this.frm.docname) {
			// use doc specific docfield object
			this.df = frappe.meta.get_docfield(
				this.frm.doctype,
				this.df.fieldname,
				this.frm.docname
			);
		} else {
			// use non-doc specific docfield
			if (this.df.options) {
				this.df =
					frappe.meta.get_docfield(this.df.options, this.df.fieldname) ||
					this.df ||
					null;
			}
		}

		if (this.doctype && this.frm) {
			this.docfields = frappe.meta.get_docfields(this.doctype, this.frm.docname);
		} else {
			// fields given in docfield
			this.docfields = this.df.fields;
		}

		this.docfields.forEach((df) => {
			this.fields_map[df.fieldname] = df;
		});
	}

	refresh_row(docname) {
		this.grid_rows_by_docname[docname] && this.grid_rows_by_docname[docname].refresh();
	}

	make_sortable($rows) {
		this.grid_sortable = new Sortable($rows.get(0), {
			group: { name: this.df.fieldname },
			handle: ".sortable-handle",
			draggable: ".grid-row",
			animation: 100,
			filter: "li, a",
			onMove: (event) => {
				// don't move if editable
				if (!this.is_editable()) {
					return false;
				}
				// prevent drag behaviour if _sortable property is "false"
				let idx = $(event.dragged).closest(".grid-row").attr("data-idx");
				let doc = this.data[idx % this.grid_pagination.page_length];
				if (doc && doc._sortable === false) {
					return false;
				}
			},
			onUpdate: (event) => {
				let idx = $(event.item).closest(".grid-row").attr("data-idx") - 1;
				let doc = this.data[idx % this.grid_pagination.page_length];
				this.renumber_based_on_dom();
				this.frm &&
					this.frm.script_manager.trigger(
						this.df.fieldname + "_move",
						this.df.options,
						doc.name
					);
				this.refresh();
				this.frm && this.frm.dirty();
			},
		});

		this.frm && $(this.frm.wrapper).trigger("grid-make-sortable", [this.frm]);
	}

	get_data(filter_field) {
		let data = [];
		if (filter_field) {
			data = this.get_filtered_data();
		} else {
			data = this.frm
				? this.frm.doc[this.df.fieldname] || []
				: this.df.data || this.get_modal_data();
		}
		return data;
	}

	get_filtered_data() {
		let all_data = this.frm ? this.frm.doc[this.df.fieldname] : this.df.data;

		if (!all_data) return;

		for (const field in this.filter) {
			all_data = all_data.filter((data) => {
				let { df, value } = this.filter[field];
				return this.get_data_based_on_fieldtype(df, data, value.toLowerCase());
			});
		}

		return all_data;
	}

	get_data_based_on_fieldtype(df, data, value) {
		let fieldname = df.fieldname;
		let fieldtype = df.fieldtype;
		let fieldvalue = data[fieldname];

		if (fieldtype === "Check") {
			value = frappe.utils.string_to_boolean(value);
			return Boolean(fieldvalue) === value && data;
		} else if (fieldtype === "Sr No" && data.idx.toString().includes(value)) {
			return data;
		} else if (fieldtype === "Duration" && fieldvalue) {
			let formatted_duration = frappe.utils.get_formatted_duration(fieldvalue);

			if (formatted_duration.includes(value)) {
				return data;
			}
		} else if (fieldtype === "Barcode" && fieldvalue) {
			let barcode = fieldvalue.startsWith("<svg")
				? $(fieldvalue).attr("data-barcode-value")
				: fieldvalue;

			if (barcode.toLowerCase().includes(value)) {
				return data;
			}
		} else if (["Datetime", "Date"].includes(fieldtype) && fieldvalue) {
			let user_formatted_date = frappe.datetime.str_to_user(fieldvalue);

			if (user_formatted_date.includes(value)) {
				return data;
			}
		} else if (["Currency", "Float", "Int", "Percent", "Rating"].includes(fieldtype)) {
			let num = fieldvalue || 0;

			if (fieldtype === "Rating") {
				let out_of_rating = parseInt(df.options) || 5;
				num = num * out_of_rating;
			}

			if (num.toString().indexOf(value) > -1) {
				return data;
			}
		} else if (fieldvalue && fieldvalue.toLowerCase().includes(value)) {
			return data;
		}
	}

	get_modal_data() {
		return this.df.get_data
			? this.df.get_data().filter((data) => {
					if (!this.deleted_docs || !this.deleted_docs.includes(data.name)) {
						return data;
					}
			  })
			: [];
	}

	set_column_disp(fieldname, show) {
		if (Array.isArray(fieldname)) {
			for (let field of fieldname) {
				this.update_docfield_property(field, "hidden", show ? 0 : 1);
				this.set_editable_grid_column_disp(field, show);
			}
		} else {
			this.get_docfield(fieldname).hidden = show ? 0 : 1;
			this.set_editable_grid_column_disp(fieldname, show);
		}

		this.debounced_refresh();
	}

	set_editable_grid_column_disp(fieldname, show) {
		//Hide columns for editable grids
		if (this.meta.editable_grid && this.grid_rows) {
			this.grid_rows.forEach((row) => {
				row.columns_list.forEach((column) => {
					//Hide the column specified
					if (column.df.fieldname == fieldname) {
						if (show) {
							column.df.hidden = false;

							//Show the static area and hide field area if it is not the editable row
							if (row != frappe.ui.form.editable_row) {
								column.static_area.show();
								column.field_area && column.field_area.toggle(false);
							}
							//Hide the static area and show field area if it is the editable row
							else {
								column.static_area.hide();
								column.field_area && column.field_area.toggle(true);

								//Format the editable column appropriately if it is now visible
								if (column.field) {
									column.field.refresh();
									if (column.field.$input)
										column.field.$input.toggleClass("input-sm", true);
								}
							}
						} else {
							column.df.hidden = true;
							column.static_area.hide();
						}
					}
				});
			});
		}

		this.refresh();
	}

	toggle_reqd(fieldname, reqd) {
		this.update_docfield_property(fieldname, "reqd", reqd);
		this.debounced_refresh();
	}

	toggle_enable(fieldname, enable) {
		this.update_docfield_property(fieldname, "read_only", enable ? 0 : 1);
		this.debounced_refresh();
	}

	toggle_display(fieldname, show) {
		this.update_docfield_property(fieldname, "hidden", show ? 0 : 1);
		this.debounced_refresh();
	}

	toggle_checkboxes(enable) {
		this.wrapper.find(".grid-row-check").prop("disabled", !enable);
	}

	get_docfield(fieldname) {
		return frappe.meta.get_docfield(
			this.doctype,
			fieldname,
			this.frm ? this.frm.docname : null
		);
	}

	get_row(key) {
		if (typeof key == "number") {
			if (key < 0) {
				return this.grid_rows[this.grid_rows.length + key];
			} else {
				return this.grid_rows[key];
			}
		} else {
			return this.grid_rows_by_docname[key];
		}
	}

	get_grid_row(key) {
		return this.get_row(key);
	}

	get_field(fieldname) {
		// Note: workaround for get_query
		if (!this.fieldinfo[fieldname]) this.fieldinfo[fieldname] = {};
		return this.fieldinfo[fieldname];
	}

	set_value(fieldname, value, doc) {
		if (this.display_status !== "None" && doc?.name && this.grid_rows_by_docname?.[doc.name]) {
			let grid_row = this.grid_rows_by_docname[doc.name];
			grid_row.refresh_field(fieldname, value);
			// re-evaluate depends_on of sibling columns that reference this field
			grid_row.refresh_dependency();
		}
	}

	setup_add_row() {
		//// Neoffice — upstream binds only ".grid-add-row" (64f4614afc, 2026-06-10): the cockpit CTA row
		//// shares the footer button's handler, so both open a new row exactly the same way.
		// .grid-append-row = the in-table CTA row (cockpit), same action
		this.wrapper.find(".grid-add-row, .grid-append-row").click(() => {
			this.add_new_row(null, null, true, null, true);
			this.set_focus_on_row();

			return false;
		});
	}

	add_new_row(idx, callback, show, copy_doc, go_to_last_page = false, go_to_first_page = false) {
		let cannot_add_rows = this.cannot_add_rows || (this.df && this.df.cannot_add_rows);
		if (this.is_editable() && !cannot_add_rows) {
			if (go_to_last_page) {
				this.grid_pagination.go_to_last_page_to_add_row();
			} else if (go_to_first_page) {
				this.grid_pagination.go_to_page(1);
			}

			if (this.frm) {
				var d = frappe.model.add_child(
					this.frm.doc,
					this.df.options,
					this.df.fieldname,
					idx
				);
				if (copy_doc) {
					d = this.duplicate_row(d, copy_doc);
				}
				d.__unedited = true;
				this.frm.script_manager.trigger(this.df.fieldname + "_add", d.doctype, d.name);
				this.refresh();
			} else {
				if (!this.df.data) {
					this.df.data = this.get_data() || [];
				}
				const defaults = this.docfields.reduce((acc, d) => {
					acc[d.fieldname] = d.default;
					return acc;
				}, {});

				const row_idx = this.df.data.length + 1;
				this.df.data.push({ idx: row_idx, __islocal: true, ...defaults });
				this.df.on_add_row && this.df.on_add_row(row_idx);
				this.refresh();
			}

			if (show) {
				if (idx) {
					// always open inserted rows
					this.wrapper
						.find("[data-idx='" + idx + "']")
						.data("grid_row")
						.toggle_view(true, callback);
				} else {
					if (!this.allow_on_grid_editing()) {
						// open last row only if on-grid-editing is disabled
						this.wrapper
							.find(".grid-row:last")
							.data("grid_row")
							.toggle_view(true, callback);
					}
				}
			}

			return d;
		}
	}

	renumber_based_on_dom() {
		// renumber based on dom
		let $rows = $(this.parent).find(".rows");

		$rows.find(".grid-row").each((i, item) => {
			let $item = $(item);
			let index =
				(this.grid_pagination.page_index - 1) * this.grid_pagination.page_length + i;
			let d = this.grid_rows_by_docname[$item.attr("data-name")].doc;
			d.idx = index + 1;
			$item.attr("data-idx", d.idx);

			if (this.frm) this.frm.doc[this.df.fieldname][index] = d;
			this.data[index] = d;
			this.grid_rows[index] = this.grid_rows_by_docname[d.name];
		});
	}

	duplicate_row(d, copy_doc) {
		$.each(copy_doc, function (key, value) {
			if (
				![
					"creation",
					"modified",
					"modified_by",
					"idx",
					"owner",
					"parent",
					"doctype",
					"name",
					"parentfield",
				].includes(key)
			) {
				d[key] = value;
			}
		});

		return d;
	}

	set_focus_on_row(idx) {
		if (!idx && idx !== 0) {
			idx = this.grid_rows.length - 1;
		}

		setTimeout(() => {
			this.grid_rows[idx].toggle_editable_row(true);
			this.grid_rows[idx].row
				.find('input[type="Text"],textarea,select')
				.filter(":visible:first")
				.focus();
		}, 100);
	}

	setup_visible_columns() {
		if (this.visible_columns && this.visible_columns.length > 0) return;

		this.user_defined_columns = [];
		this.setup_user_defined_columns();
		var total_colsize = 1,
			fields =
				this.user_defined_columns && this.user_defined_columns.length > 0
					? this.user_defined_columns
					: this.editable_fields || this.docfields;

		this.visible_columns = [];

		//// Neoffice — upstream hardcodes 11 as the cap on the sum of the column sizes (`if (total_colsize >
		//// 11) return false;` below), which silently drops the in-list-view columns past it. 4e23539603
		//// (2024-09-23 "last updates") first introduced limit_colsize as a VAT Declaration special case (20
		//// instead of 11); 051206fa6b (2025-11-08 "fix: Grid fullwidth toggle with horizontal scroll")
		//// generalised it to 999 — no column is dropped any more, and grid_row.js switches the grid to
		//// horizontal scroll past 10 (.column-limit-reached, marked there).
		//// Measured 2026-09-09 (neoffice-maintenance#205): `VAT Detail` carries 16 in-list-view columns,
		//// `VAT Declaration Summary` 13, `Booking Extra` 11 — upstream's cap of 10 would HIDE six columns
		//// of the Swiss VAT detail grid. The price is that every in-list-view column renders on every
		//// child table; that is the price of showing the columns the user marked. Kept, deliberately.
		// No limit on column size - horizontal scroll will be enabled automatically
		let limit_colsize = 999;

		for (var ci in fields) {
			var _df = fields[ci];

			// get docfield if from fieldname
			df =
				this.user_defined_columns && this.user_defined_columns.length > 0
					? _df
					: this.fields_map[_df.fieldname];

			if (
				df &&
				!df.hidden &&
				(this.editable_fields || df.in_list_view) &&
				((this.frm && this.frm.get_perm(df.permlevel, "read")) || !this.frm) &&
				!frappe.model.layout_fields.includes(df.fieldtype)
			) {
				if (df.columns) {
					df.colsize = df.columns;
				} else {
					this.update_default_colsize(df);
				}

				// attach formatter on refresh
				if (
					df.fieldtype == "Link" &&
					!df.formatter &&
					df.parent &&
					frappe.meta.docfield_map[df.parent]
				) {
					const docfield = frappe.meta.docfield_map[df.parent][df.fieldname];
					if (docfield && docfield.formatter) {
						df.formatter = docfield.formatter;
					}
				}

				total_colsize += df.colsize;
				//// Neoffice — 4e23539603 (2024-09-23) replaced upstream's literal 11 with limit_colsize, now 999 (see
				//// the marker above). The redistribute loop that follows is upstream's again: 051206fa6b reverted the
				//// three other substitutions 4e23539603 had made in it, so only its two comment lines are ours.
				if (total_colsize > limit_colsize) return false; //// replaced 11 with limit_colsize
				this.visible_columns.push([df, df.colsize]);
			}
		}

		// Redistribute column sizes only for small tables (< 11 columns)
		// For larger tables, horizontal scroll will be enabled
		var passes = 0;
		while (total_colsize < 11 && passes < 12) {
			for (var i in this.visible_columns) {
				var df = this.visible_columns[i][0];
				var colsize = this.visible_columns[i][1];
				if (colsize > 1 && colsize < 11 && frappe.model.is_non_std_field(df.fieldname)) {
					if (
						passes < 3 &&
						["Int", "Currency", "Float", "Check", "Percent"].indexOf(df.fieldtype) !==
							-1
					) {
						// don't increase col size of these fields in first 3 passes
						continue;
					}

					this.visible_columns[i][1] += 1;
					total_colsize++;
				}

				if (total_colsize > 10) break;
			}
			passes++;
		}
	}

	update_default_colsize(df) {
		var colsize = 2;
		switch (df.fieldtype) {
			case "Text":
				break;
			case "Small Text":
				colsize = 3;
				break;
			case "Check":
				colsize = 1;
		}
		df.colsize = colsize;
	}

	setup_user_defined_columns() {
		if (!this.frm) return;

		let user_settings = frappe.get_user_settings(this.frm.doctype, "GridView");
		if (user_settings && user_settings[this.doctype] && user_settings[this.doctype].length) {
			this.user_defined_columns = user_settings[this.doctype]
				.map((row) => {
					let column =
						this.docfields?.find((d) => d.fieldname === row.fieldname) ||
						frappe.meta.get_docfield(this.doctype, row.fieldname);

					if (column) {
						column.in_list_view = 1;
						column.columns = row.columns;
						//// Neoffice — added (051206fa6b, 2025-11-08): carries the per-column "sticky" flag of the user's
						//// GridView settings into visible_columns. grid_row.js pins those columns to the left while the grid
						//// is in horizontal-scroll mode (marked there). Upstream has no sticky columns.
						column.sticky = row.sticky || false;
						return column;
					}
				})
				.filter(Boolean);
		}
	}

	is_editable() {
		return this.display_status == "Write" && !this.static_rows;
	}

	is_sortable() {
		return this.sortable_status || this.is_editable();
	}

	only_sortable(status) {
		if (status === undefined ? true : status) {
			this.sortable_status = true;
			this.static_rows = true;
		}
	}

	set_multiple_add(link, qty) {
		if (this.multiple_set) return;

		var link_field = frappe.meta.get_docfield(this.df.options, link);
		var btn = $(this.wrapper).find(".grid-add-multiple-rows");

		// show button
		btn.removeClass("hidden");

		// open link selector on click
		btn.on("click", () => {
			new frappe.ui.form.LinkSelector({
				doctype: link_field.options,
				fieldname: link,
				qty_fieldname: qty,
				get_query: link_field.get_query,
				target: this,
				txt: "",
			});
			this.grid_pagination.go_to_last_page_to_add_row();
			return false;
		});
		this.multiple_set = true;
	}

	setup_allow_bulk_edit() {
		let me = this;
		if (this.frm && this.frm.get_docfield(this.df.fieldname)?.allow_bulk_edit) {
			// download
			this.setup_download();

			const value_formatter_map = {
				Date: (val) => (val ? frappe.datetime.user_to_str(val) : val),
				Int: (val) => cint(val),
				Check: (val) => cint(val),
				Float: (val) => flt(val),
				Currency: (val) => flt(val),
			};

			// upload
			frappe.flags.no_socketio = true;
			$(this.wrapper)
				.find(".grid-upload")
				.removeClass("hidden")
				.on("click", () => {
					new frappe.ui.FileUploader({
						as_dataurl: true,
						allow_multiple: false,
						restrictions: {
							allowed_file_types: [".csv"],
						},
						on_success(file) {
							var data = frappe.utils.csv_to_array(
								frappe.utils.get_decoded_string(file.dataurl)
							);
							if (cint(data.length) - 7 > 5000) {
								frappe.throw(__("Cannot import table with more than 5000 rows."));
							}
							// row #2 contains fieldnames;
							var fieldnames = data[2];
							me.frm.clear_table(me.df.fieldname);
							$.each(data, (i, row) => {
								if (i > 6) {
									var blank_row = true;
									$.each(row, function (ci, value) {
										if (value) {
											blank_row = false;
											return false;
										}
									});

									if (!blank_row) {
										var d = me.frm.add_child(me.df.fieldname);
										$.each(row, (ci, value) => {
											var fieldname = fieldnames[ci];
											var df = frappe.meta.get_docfield(
												me.df.options,
												fieldname
											);
											if (df) {
												d[fieldnames[ci]] = value_formatter_map[
													df.fieldtype
												]
													? value_formatter_map[df.fieldtype](value)
													: value;
											}
										});
									}
								}
							});

							me.frm.refresh_field(me.df.fieldname);
							frappe.msgprint({
								message: __("Table updated"),
								title: __("Success"),
								indicator: "green",
							});
						},
					});
					return false;
				});
		}
	}

	setup_download() {
		let title = this.df.label || frappe.model.unscrub(this.df.fieldname);
		$(this.wrapper)
			.find(".grid-download")
			.removeClass("hidden")
			.on("click", () => {
				var data = [];
				var docfields = [];
				data.push([__("Bulk Edit {0}", [title])]);
				data.push([]);
				data.push([]);
				data.push([]);
				data.push([__("The CSV format is case sensitive")]);
				data.push([__("Do not edit headers which are preset in the template")]);
				data.push(["------"]);
				$.each(frappe.get_meta(this.df.options).fields, (i, df) => {
					// don't include the read-only field in the template
					if (frappe.model.is_value_type(df.fieldtype)) {
						data[1].push(df.label);
						data[2].push(df.fieldname);
						let description = (df.description || "") + " ";
						if (df.fieldtype === "Date") {
							description += frappe.boot.sysdefaults.date_format;
						}
						data[3].push(description);
						docfields.push(df);
					}
				});

				// add data
				$.each(this.frm.doc[this.df.fieldname] || [], (i, d) => {
					var row = [];
					$.each(data[2], (i, fieldname) => {
						var value = d[fieldname];

						// format date
						if (docfields[i].fieldtype === "Date" && value) {
							value = frappe.datetime.str_to_user(value);
						}

						row.push(value || "");
					});
					data.push(row);
				});

				frappe.tools.downloadify(data, null, title);
				return false;
			});
	}

	add_custom_button(label, click, position = "bottom") {
		// add / unhide a custom button
		const $wrapper = position === "top" ? this.grid_custom_buttons : this.grid_buttons;
		let $btn = this.custom_buttons[label];
		if (!$btn) {
			$btn = $(`<button type="button" class="btn btn-secondary btn-xs btn-custom">`)
				.html(__(label))
				.prependTo($wrapper)
				.on("click", click);
			this.custom_buttons[label] = $btn;
		} else {
			$btn.removeClass("hidden");
		}
		return $btn;
	}

	clear_custom_buttons() {
		// hide all custom buttons
		this.grid_buttons.find(".btn-custom").addClass("hidden");
	}

	update_docfield_property(fieldname, property, value) {
		// update the docfield of each row
		if (!this.grid_rows) {
			return;
		}

		for (let row of this.grid_rows) {
			if (!row) continue;

			let docfield = row.docfields?.find((d) => d.fieldname === fieldname);
			if (docfield) {
				docfield[property] = value;
			} else {
				throw `field ${fieldname} not found`;
			}
		}

		// update the parent too (for new rows)
		this.docfields.find((d) => d.fieldname === fieldname)[property] = value;

		if (this.user_defined_columns && this.user_defined_columns.length > 0) {
			let field = this.user_defined_columns.find((d) => d.fieldname === fieldname);
			if (field && Object.keys(field).includes(property)) {
				field[property] = value;
			}
		}

		this.debounced_refresh();
	}

	get_current_row(target) {
		let current_row = null;
		for (let i = 0; i < this.grid_rows.length; i++) {
			if (this.grid_rows[i]?.wrapper.get(0).contains(target)) {
				current_row = i;
			}
		}
		return current_row;
	}
}
